import React, {PropTypes} from 'react';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import LoggedinFooter from '../footer/loggedin_footer';
import cookies from '../util/cookie';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import CONSTANTS from '../common_constants';
import ShowError from '../components/error/show_error';
import shipmentActions from '../shipment/shipment_actions.jsx';
import moment from 'moment';
import MediaQuery from 'react-responsive';
import Rating from '../components/rating/rating';
import PhoneNumber from 'react-phone-number';
import {Link, browserHistory} from 'react-router';
import authActions from '../auth/auth_actions';
import './agent_widget.less';

export default class AgentInfo extends React.Component{
  constructor(props){
    super(props);
    let agentInfo = '';
    agentInfo = props.agentInfo ? props.agentInfo : this.getAgentInfo(props.shipment);
    const shipmentInfo = props.shipment ? this.getShipmentInfo(props.shipment) : '';
    this.state = {
      agentInfo,
      shipmentInfo
    };
  }

  getAgentInfo = (shipment) => {
    let agentInfo, agentType;

    if(shipment.isShipper || shipment.isReceiver){
      agentInfo = shipment.carrierInfo;
      agentType = shipment.isReceiver ? "RECEIVER" : "CARRIER";
    }
    else if(!shipment.isShipper){
      agentInfo = shipment.shipperInfo;
      agentType="SHIPPER";
    }

    if (agentInfo) {
      return({
        imageUrl: agentInfo.profileImgUrl || "../../public/images/user_placeholder.svg",
        name: agentInfo.name,
        email: agentInfo.email,
        phoneNo: agentInfo.phoneNumber,
        totalNoOfRatings: agentInfo.totalNoOfRatings,
        averageRating: agentInfo.averageRating,
        agentType: agentType,
      });
    }
    return false;
  }

  getShipmentInfo = (shipment) => {
    // let deliveryCity = shipment.deliveryCity ? shipment.deliveryCity : '';
    // let deliveryCountry = shipment.deliveryCountry ? shipment.deliveryCountry : '';
    const deliveryLocation = shipment.deliveryLocation;

      return({
        shipmentId: shipment.shipmentId,
        title: shipment.title,
        shipmentImg: shipment.thumbnailImage,
        packageValue: shipment.itemValue,
        shipmentStatus: shipment.shipmentStatus,
        packageSize: CONSTANTS.packageSize[shipment.itemSize],
        deliverBy: shipment.deliveryDate
            ? moment(shipment.deliveryDate).format('ll')
            : '',
        pickupLocation: shipment.pickupLocation,
        deliverBy: shipment.deliveryDate
            ? moment(shipment.deliveryDate).format('ll')
            : '',
        pickupLocation: shipment.pickupLocation,
        deliveryLocation: deliveryLocation
      });
  }

  render(){
    const {state,props} = this;
    const {agentInfo,shipmentInfo} = state;
    let map_img_url = "../../../public/images/map_img/icn_location_with_shadow.png";
    let defaultImgUrl = "../../../public/images/requester_flow/placeholder.png";
    if(!shipmentInfo.shipmentImg || shipmentInfo.shipmentImg =="")
      shipmentInfo.shipmentImg = defaultImgUrl;
    const call = agentInfo.phoneNo ? "tel:"+agentInfo.phoneNo : '';
    let url;
    (this.props.backTo) ? (url = "/shipment/"+ this.props.shipmentId + "?backTo=" + this.props.backTo) : (url = "/shipment/"+shipmentInfo.shipmentId);
    let agentInfoSection = agentInfo &&  (agentInfo.email || shipmentInfo.shipmentStatus >= CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED );
    console.log('sagent', agentInfo.phoneNo);
    return(
      <div className = "agent-info-widget">
        {
          agentInfo &&
          <div className = "agent-info profile-info-wrp">
          {
            agentInfo.agentType && <MediaQuery query='(max-width: 767px)'>
              <div className="agent-type">{agentInfo.agentType}</div>
            </MediaQuery>}
            <div className = "profile-info">
              <div className = "profile-img" style = {{"backgroundImage": 'url("' + agentInfo.imageUrl + '")'}}></div>
              <div className = "agent-type-info">
                <h2 title={agentInfo.name} className = "name">{agentInfo.name}</h2>
                {
                  agentInfo.agentType && <MediaQuery query='(min-width: 768px)'>
                    <div className = "agent-type">{agentInfo.agentType}</div>
                  </MediaQuery>
                }
                <MediaQuery query='(max-width: 767px)'>
                  <div className="rating"><Rating rating={agentInfo.averageRating} ratingSize={"rating-size10"}/><span className="reviewNumber">({agentInfo.totalNoOfRatings})</span></div>
                </MediaQuery>
              </div>
            </div>
              <MediaQuery query='(min-width: 768px)' >
                <div className="rating">
                  <Rating rating={agentInfo.averageRating} ratingSize={"rating-size10"}/><span className="reviewNumber">({agentInfo.totalNoOfRatings})</span>
                </div>
              </MediaQuery>
            </div>
        }
        {
          agentInfoSection &&

          <div className = "agent-info contact-info">
            {
              agentInfo.email &&
                <div className = "contact-wrap">
                  <div className = "contact-label">Email</div>
                  <div className = "contact-value">{agentInfo.email}</div>
                </div>
            }
            {
              shipmentInfo.shipmentStatus >= CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED && agentInfo.phoneNo && <div className = "contact-wrap">
                <div className = "contact-label">Phone Number</div>
                <div className = "contact-value"><a href={call}><PhoneNumber number={agentInfo.phoneNo} /></a></div>
              </div>
            }
          </div>
        }
        <div className = "agent-info shipment-info">
          <div className = "shipment-info-wrp">
            <div className = "img-wrap" style = {{"backgroundImage": 'url("' + shipmentInfo.shipmentImg + '")'}}></div>
            <div className = "sub-info">
              <h2 className = "shipment-title">{shipmentInfo.title}</h2>
              <div className = "package-info"><span className = "icon-cash-in-hand img-icn"></span>${shipmentInfo.packageValue} Value</div>
              {shipmentInfo.packageSize && <div className = "package-info"><span className = "icon-box-front img-icn"></span>{shipmentInfo.packageSize}</div>}
              <div className = "package-info"><span className = "icon-calendar img-icn"></span>{shipmentInfo.deliverBy}</div>
            </div>
          </div>
          <div className = "shipment-info-wrp">
            <div className = "img-wrap" style = {{"backgroundImage": 'url("' + map_img_url + '")'}}></div>
            <div className = "sub-info">
              <div className = "sub-header">Pickup Location</div>
              <div className = "sub-info-content">{shipmentInfo.pickupLocation}</div>
            </div>
          </div>
          <div className = "shipment-info-wrp">
            <div className = "img-wrap" style = {{"backgroundImage": 'url("' + map_img_url + '")'}}></div>
            <div className = "sub-info">
              <div className = "sub-header">Delivery Location</div>
              <div className = "sub-info-content">{shipmentInfo.deliveryLocation}</div>
            </div>
          </div>
          {/*<div className = "shipment-info-wrp btn-wrap">
          //   <Link to ={url}>
          //     <button className = "btn orange">View Full Details</button>
          //   </Link>
          // </div>*/}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// app/messages/agent_widget.jsx